// extracted by mini-css-extract-plugin
export default {"h1":"Copyright_h1__0W1Vq","h3":"Copyright_h3__D0DKU","text":"Copyright_text__9AsXB"};